module.exports = __webpack_public_path__ + "img/lair-onfire1.1f8a5cf7.jpeg";